
import * as vClickOutside from "v-click-outside";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      menuOpen: false,
      isMounted: false,
      searchOpen: false,
      showNewsletter: false,
      profileOptions: false,
      languageSwitcherOpen: false,
    };
  },

  watch: {
    $route() {
      this.closeMenu();
      this.closeSearch();
      this.closeProfileOptions();
      this.closeLanguageSwitcher();
    },
  },

  computed: {
    total() {
      if (!this.isMounted) return;
      else {
        let sum = 0;

        if (
          this.$refs.cart &&
          this.$refs.cart.cartItems &&
          this.$refs.cart.cartItems.length
        ) {
          this.$refs.cart.cartItems.forEach(
            (product) => (sum = sum + product.qty)
          );
        }
        return sum;
      }
    },
  },

  mounted() {
    this.isMounted = true;
    const newsletterCookie = this.$getCookie("newsletterCookie");

    if (newsletterCookie === undefined) {
      this.showNewsletter = true;
      this.$setCookie("newsletterCookie", true);
    } else {
      this.showNewsletter = newsletterCookie;
    }
  },

  methods: {
    openLanguageSwitcher() {
      this.languageSwitcherOpen = true;
    },

    closeLanguageSwitcher() {
      this.languageSwitcherOpen = false;
    },

    openProfileOptions() {
      this.profileOptions = true;
    },

    closeProfileOptions() {
      this.profileOptions = false;
    },

    closeNewsletter() {
      this.$setCookie("newsletterCookie", false);
      this.showNewsletter = false;

      const newsletterCookie = this.$getCookie("newsletterCookie");
    },

    toggleMenu(e) {
      const el = e.currentTarget;

      if (el) {
        el.classList.toggle("menuOpen");

        this.menuOpen = el.classList.contains("menuOpen");
      }

      const element = document.documentElement;
      if (element) {
        if (this.menuOpen) {
          element.classList.add("overflow-hidden");
        } else {
          element.classList.remove("overflow-hidden");
        }
      }
    },
    closeMenu() {
      this.menuOpen = false;
      const openClass = document.getElementsByClassName("menuOpen");
      if (openClass && openClass[0]) {
        openClass[0].classList.remove("menuOpen");
      }

      const element = document.documentElement;
      if (element) {
        element.classList.remove("overflow-hidden");
      }
    },

    openSearch() {
      this.searchOpen = true;
      if (this.menuOpen) {
        this.menuOpen = false;
      }

      const element = document.documentElement;
      if (element) {
        element.classList.add("overflow-hidden");
      }

      if (document.getElementById("searchInput")) {
        setTimeout(() => {
          document.getElementById("searchInput").focus();
        }, 300);
      }
    },

    closeSearch() {
      this.searchOpen = false;

      const element = document.documentElement;
      if (element) {
        element.classList.remove("overflow-hidden");
      }
    },

    returnLanguageName(language) {
      let langName;

      switch (language.code) {
        case "hr":
          langName = this.$t("text.croatian");
          break;
        case "en":
          langName = this.$t("text.english");
          break;
        default:
          langName = language.name;
      }

      return langName;
    },
  },
};
